import { Storage } from './storage';
export { Storage };



//////////////////
// WEBPACK FOOTER
// ./~/@ionic/storage/es2015/index.js
// module id = 331
// module chunks = 0